
import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Cabecalho from '../cabecalho/Cabecalho';
import Rodape from '../rodape/Rodape';
import Menu from '../menu/Menu';
import Titulo from '../titulo/Titulo';

// IMPORTAÇÃO DOS SERVICES
import UsuariosService from '../../service/usuario';
import NotificacaoService from '../../service/notificacoes';
import ComunicadosService from '../../service/comunicados/ComunicadosService';

// =============================================================================
// TELA: COMUNICAÇÕES ESPECIAIS (apenas Admin)
// =============================================================================
// - Automacao de Designacoes Pendentes
// - Comunicados (Pop-ups Dinamicos): lista, filtros, criar, disparar
// - Historico das pop-ups dinamicas
// A parte de "Enviar Notificacao" + historico de notificacoes fica na pagina
// /notificacoes (componente Comunicacoes).
// =============================================================================

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: #fff;
`;

const MainContent = styled.main`
    padding-top: 85px;
    padding-left: 260px;
    padding-right: 24px;
    padding-bottom: 60px;
    box-sizing: border-box;
    flex: 1 0 auto;
    @media (max-width: 1200px) and (min-width: 768px) {
        padding-left: 80px;
    }
    @media (max-width: 767px) {
        padding-left: 16px;
        padding-right: 16px;
        padding-bottom: 16px;
    }
`;

const Container = styled.div`
    padding: 24px;
    max-width: 1200px;
    margin: 0 auto;
    font-family: 'Roboto', sans-serif;
`;

const SectionTitle = styled.h2`
    font-size: 18px;
    font-weight: 700;
    color: #008080;
    margin: 24px 0 12px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    gap: 8px;
`;

// ===== AUTOMACAO =====

const AutomacaoBox = styled.div`
    background: #f0fdfd;
    border: 1px solid #008080;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

const AutomacaoDescricao = styled.p`
    font-size: 13px;
    color: #666;
    margin: 8px 0 0 28px;
`;

// ===== FILTROS =====

const FiltrosContainer = styled.div`
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;
`;

const FiltroGroup = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 200px;
    flex: 1;
`;

const Label = styled.label`
    font-weight: 600;
    color: #333;
    margin-bottom: 6px;
    font-size: 14px;
`;

const Select = styled.select`
    padding: 10px 14px;
    border: 1px solid #008080;
    background: white;
    color: #008080;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    outline: none;
    option { color: #333; background: white; }
`;

const InputText = styled.input`
    padding: 10px 14px;
    border: 1px solid #008080;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    outline: none;
    &:focus { box-shadow: 0 0 0 2px rgba(0, 128, 128, 0.2); }
`;

// ===== BOTOES =====

const PrimaryButton = styled.button`
    background: #008080;
    border: none;
    color: white;
    padding: 10px 24px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    margin-right: 8px;
    &:hover { background: #006666; }
    &:disabled { background: #ccc; cursor: not-allowed; }
`;

const SecondaryButton = styled.button`
    background: white;
    border: 1px solid #008080;
    color: #008080;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    margin-right: 8px;
    &:hover { background: #f0fdfd; }
`;

const DangerButton = styled.button`
    background: white;
    border: 1px solid #d32f2f;
    color: #d32f2f;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    &:hover { background: #fde8e8; }
`;

// Par de botoes Ativar / Desativar da automacao.
// Regra visual: o botao que corresponde ao estado ATUAL fica "mais claro"
// (esmaecido e desabilitado); o outro fica em destaque.
const ToggleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
`;

const ToggleBtn = styled.button`
    padding: 10px 24px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 700;
    border: 1px solid #008080;
    cursor: pointer;
    transition: opacity .15s ease, background .15s ease;
    &:disabled { cursor: default; }
`;

const BtnAtivar = styled(ToggleBtn)`
    background: ${(p) => (p.$ativo ? '#e3f2f2' : '#008080')};
    color: ${(p) => (p.$ativo ? '#5aa0a0' : '#fff')};
    border-color: ${(p) => (p.$ativo ? '#bfe0e0' : '#008080')};
    opacity: ${(p) => (p.$ativo ? 0.55 : 1)};
    &:hover:not(:disabled) { background: #006666; }
`;

const BtnDesativar = styled(ToggleBtn)`
    background: ${(p) => (p.$ativo ? '#fff' : '#f5e6e6')};
    color: ${(p) => (p.$ativo ? '#d32f2f' : '#caa5a5')};
    border-color: ${(p) => (p.$ativo ? '#d32f2f' : '#e2c9c9')};
    opacity: ${(p) => (p.$ativo ? 1 : 0.55)};
    &:hover:not(:disabled) { background: #fde8e8; }
`;

const StatusPill = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 700;
    padding: 4px 12px;
    border-radius: 999px;
    background: ${(p) => (p.$ativo ? '#008080' : '#e0e0e0')};
    color: ${(p) => (p.$ativo ? '#fff' : '#666')};
`;

// ===== TESTE DO DISPARO (por publicador) =====

const TesteWrap = styled.div`
    margin-top: 16px;
    padding-top: 14px;
    border-top: 1px dashed #9fcccc;
`;

const BuscaWrap = styled.div`
    position: relative;
    max-width: 420px;
`;

const BuscaDrop = styled.div`
    position: absolute;
    z-index: 20;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #cfd6d4;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
    max-height: 240px;
    overflow-y: auto;
`;

const BuscaItem = styled.button`
    display: block;
    width: 100%;
    text-align: left;
    border: none;
    background: none;
    padding: 9px 12px;
    font-size: 13px;
    color: #1e293b;
    cursor: pointer;
    &:hover { background: #f0fdfd; }
    & + & { border-top: 1px solid #eef2f1; }
`;

const ChipUsuario = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #e3f2f2;
    border: 1px solid #bfe0e0;
    color: #0b5c5c;
    font-size: 13px;
    font-weight: 600;
    padding: 5px 10px;
    border-radius: 999px;
`;

const ChipX = styled.button`
    border: none;
    background: none;
    color: #0b5c5c;
    font-size: 15px;
    line-height: 1;
    cursor: pointer;
    padding: 0;
    &:hover { color: #d32f2f; }
`;

// ===== HISTORICO =====

const HistoricoBox = styled.div`
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    max-height: 320px;
    overflow-y: auto;
    padding: 8px;
    margin-bottom: 24px;
`;

const HistoricoItem = styled.div`
    padding: 12px;
    border-radius: 6px;
    margin-bottom: 6px;
    background: #f8f9fa;
    border-left: 4px solid #DB1212;
`;

const HistoricoBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: bold;
    color: white;
    background: #DB1212;
`;

const HistoricoInfo = styled.div`
    font-size: 12px;
    color: #777;
    margin-top: 4px;
`;

// ===== COMUNICADOS =====

const ToolbarCom = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 12px;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 16px;
`;

const Card = styled.div`
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

const CardTitulo = styled.h3`
    margin: 8px 0 4px 0;
    font-size: 16px;
    color: #333;
    font-weight: 700;
`;

const CardMensagem = styled.p`
    margin: 8px 0;
    font-size: 14px;
    color: #555;
    line-height: 1.4;
    max-height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
`;

const Badge = styled.span`
    display: inline-block;
    background: ${(props) => {
        if (props.$tipo === 'informativo') return '#0288d1';
        if (props.$tipo === 'sim_nao') return '#7b1fa2';
        if (props.$tipo === 'multipla_escolha') return '#f57c00';
        if (props.$tipo === 'texto_livre') return '#388e3c';
        return '#757575';
    }};
    color: white;
    font-size: 11px;
    font-weight: bold;
    padding: 3px 8px;
    border-radius: 12px;
    text-transform: uppercase;
    margin-right: 6px;
`;

const CardInfo = styled.div`
    display: flex;
    gap: 12px;
    margin-top: 8px;
    font-size: 12px;
    color: #777;
`;

const CardAcoes = styled.div`
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
`;

const Loading = styled.div`
    text-align: center;
    padding: 40px;
    color: #008080;
`;

const ErrorMessage = styled.div`
    background: #fde8e8;
    color: #c62828;
    padding: 12px 16px;
    border-radius: 6px;
    margin-bottom: 16px;
`;

const EmptyState = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #999;
    font-style: italic;
`;

// =============================================================================
// COMPONENTE PRINCIPAL
// =============================================================================

const ComunicacoesEspeciais = () => {
    const navigate = useNavigate();
    const userId = typeof window !== 'undefined' ? localStorage.getItem('idUsuario') : null;

    // PERFIS
    const [perfilUsuario, setPerfilUsuario] = useState([]);
    const [verificandoPerfil, setVerificandoPerfil] = useState(true);
    const isAdmin = useMemo(() => perfilUsuario.includes('admin'), [perfilUsuario]);

    // HISTORICO (pop-ups)
    const [historico, setHistorico] = useState([]);

    // AUTOMACAO DE DESIGNACOES PENDENTES
    const [autoConfig, setAutoConfig] = useState(null);
    const [autoLoading, setAutoLoading] = useState(true);
    const [autoSalvando, setAutoSalvando] = useState(false);

    // TESTE DO DISPARO (para 1 publicador escolhido)
    const [testeBusca, setTesteBusca] = useState('');
    const [testeResultados, setTesteResultados] = useState([]);
    const [testeBuscando, setTesteBuscando] = useState(false);
    const [testeDropAberto, setTesteDropAberto] = useState(false);
    const [testeSelecionado, setTesteSelecionado] = useState(null);
    const [testeDisparando, setTesteDisparando] = useState(false);
    const [testeMsg, setTesteMsg] = useState(null); // { tipo: 'ok'|'erro', texto }

    // COMUNICADOS
    const [comunicados, setComunicados] = useState([]);
    const [loadingCom, setLoadingCom] = useState(true);
    const [filtroTipoCom, setFiltroTipoCom] = useState('todos');
    const [filtroStatusCom, setFiltroStatusCom] = useState('ativos');
    const [buscaCom, setBuscaCom] = useState('');
    const [desativandoId, setDesativandoId] = useState(null);

    const [erro, setErro] = useState(null);

    // ====== CARREGAMENTO INICIAL ======
    useEffect(() => {
        const fetchPerfil = async () => {
            if (!userId) { setVerificandoPerfil(false); return; }
            try {
                const dadosUsuario = await UsuariosService.getUsuarioById(userId).catch(() => null);
                if (dadosUsuario) {
                    const perfis = Array.isArray(dadosUsuario.perfil) ? dadosUsuario.perfil : (dadosUsuario.perfil ? [dadosUsuario.perfil] : []);
                    setPerfilUsuario(perfis);
                    try { localStorage.setItem('perfilUsuario', JSON.stringify(perfis)); } catch (e) {}
                }
            } catch (err) {
                console.error('Erro ao inicializar Comunicacoes Especiais:', err);
            } finally {
                setVerificandoPerfil(false);
            }
        };
        fetchPerfil();
    }, [userId]);

    useEffect(() => {
        if (!verificandoPerfil) {
            carregarHistorico();
            carregarComunicados();
            carregarConfigAutomacao();
        }
    }, [verificandoPerfil]);

    const carregarConfigAutomacao = async () => {
        setAutoLoading(true);
        try {
            const cfg = await NotificacaoService.getConfigDesignacoesPendentes();
            setAutoConfig(cfg || null);
        } catch (err) {
            console.error('Erro ao carregar config da automacao:', err);
        } finally {
            setAutoLoading(false);
        }
    };

    // Salva parte da config (ativo / horaDisparo) e atualiza o estado local
    const salvarConfigAutomacao = async (patch) => {
        setAutoSalvando(true);
        setErro(null);
        try {
            const cfg = await NotificacaoService.atualizarConfigDesignacoesPendentes(patch);
            setAutoConfig(cfg || null);
        } catch (err) {
            const msgBackend = err?.response?.data?.erro;
            setErro(msgBackend || 'Nao foi possivel salvar a configuracao da automacao.');
            // Recarrega para desfazer o estado otimista
            await carregarConfigAutomacao();
        } finally {
            setAutoSalvando(false);
        }
    };

    // ---- Teste do disparo: busca de usuário (debounce) ----
    useEffect(() => {
        const termo = testeBusca.trim();
        if (testeSelecionado || termo.length < 2) {
            setTesteResultados([]);
            return undefined;
        }
        setTesteBuscando(true);
        const t = setTimeout(async () => {
            try {
                const res = await UsuariosService.searchUsuarios(termo, { incluirAdmin: true });
                setTesteResultados(Array.isArray(res) ? res.slice(0, 20) : []);
                setTesteDropAberto(true);
            } catch (e) {
                setTesteResultados([]);
            } finally {
                setTesteBuscando(false);
            }
        }, 350);
        return () => clearTimeout(t);
    }, [testeBusca, testeSelecionado]);

    const escolherUsuarioTeste = (u) => {
        setTesteSelecionado(u);
        setTesteBusca('');
        setTesteResultados([]);
        setTesteDropAberto(false);
        setTesteMsg(null);
    };

    const limparUsuarioTeste = () => {
        setTesteSelecionado(null);
        setTesteMsg(null);
    };

    const handleDispararTeste = async () => {
        if (!testeSelecionado?._id) return;
        if (!window.confirm(
            `Disparar agora as notificações de designação pendente de "${testeSelecionado.nome}"?\n\n` +
            `Isso envia o push de Aceita/Recusa mesmo que já tenha sido enviado antes (modo teste).`
        )) return;
        setTesteDisparando(true);
        setTesteMsg(null);
        try {
            const data = await NotificacaoService.dispararTesteDesignacoesPendentes(testeSelecionado._id);
            setTesteMsg({ tipo: 'ok', texto: data?.mensagem || 'Teste disparado.' });
            await carregarConfigAutomacao();
        } catch (err) {
            const status = err?.response?.status;
            const msgBackend = err?.response?.data?.erro;
            setTesteMsg({ tipo: 'erro', texto: `Erro ${status || ''}: ${msgBackend || err?.message || 'desconhecido'}` });
        } finally {
            setTesteDisparando(false);
        }
    };

    const carregarHistorico = async () => {
        try {
            const hist = await NotificacaoService.getHistorico();
            setHistorico(Array.isArray(hist) ? hist : []);
        } catch (err) {
            console.error('Erro ao carregar historico:', err);
        }
    };

    const carregarComunicados = async () => {
        setLoadingCom(true);
        try {
            const lista = await ComunicadosService.listar();
            setComunicados(Array.isArray(lista) ? lista : []);
        } catch (err) {
            console.error('Erro ao carregar comunicados:', err);
        } finally {
            setLoadingCom(false);
        }
    };

    const formatarData = (iso) => {
        if (!iso) return '-';
        try { return new Date(iso).toLocaleString('pt-BR'); } catch { return iso; }
    };

    // Historico apenas das pop-ups
    const historicoPopups = useMemo(
        () => historico.filter(h => h.tipo === 'popup'),
        [historico]
    );

    // ====== COMUNICADOS ======
    const comunicadosFiltrados = useMemo(() => {
        return comunicados.filter(c => {
            if (filtroStatusCom === 'ativos' && !c.ativo) return false;
            if (filtroStatusCom === 'inativos' && c.ativo) return false;
            if (filtroTipoCom !== 'todos' && c.tipoPopup !== filtroTipoCom) return false;
            if (buscaCom.trim()) {
                const b = buscaCom.toLowerCase();
                if (!c.titulo.toLowerCase().includes(b) && !c.mensagem.toLowerCase().includes(b)) return false;
            }
            return true;
        });
    }, [comunicados, filtroTipoCom, filtroStatusCom, buscaCom]);

    const handleDispararCom = async (id) => {
        if (!window.confirm('Disparar push agora?')) return;
        try {
            const resultado = await ComunicadosService.disparar(id);
            alert(`Enviado para ${resultado.sucessos} dispositivo(s)!`);
            await carregarComunicados();
            await carregarHistorico();
        } catch (err) {
            const status = err?.response?.status;
            const msgBackend = err?.response?.data?.erro;
            alert(`Erro ${status || ''}: ${msgBackend || err?.message || 'desconhecido'}`);
        }
    };

    const handleApagarCom = async (c) => {
        if (c.totalEnvios > 0) {
            alert('Este comunicado ja foi disparado e NAO pode ser apagado (preserva os resultados).');
            return;
        }
        if (!window.confirm(`Apagar "${c.titulo}"?`)) return;
        setDesativandoId(c._id);
        try {
            await ComunicadosService.desativar(c._id);
            await carregarComunicados();
        } catch (err) {
            const status = err?.response?.status;
            const msgBackend = err?.response?.data?.erro;
            alert(`Erro ${status || ''}: ${msgBackend || err?.message || 'desconhecido'}`);
        } finally {
            setDesativandoId(null);
        }
    };

    const labelTipoPopup = (tipo) => {
        switch (tipo) {
            case 'informativo': return 'INFORMATIVO';
            case 'sim_nao': return 'SIM/NÃO';
            case 'multipla_escolha': return 'ENQUETE';
            case 'texto_livre': return 'TEXTO LIVRE';
            default: return (tipo || '').toUpperCase();
        }
    };

    // ====== RENDER ======
    if (verificandoPerfil) {
        return (
            <PageWrapper>
                <Menu />
                <Cabecalho />
                <MainContent>
                    <Container>
                        <Loading>Verificando permissoes...</Loading>
                    </Container>
                </MainContent>
            </PageWrapper>
        );
    }

    if (!isAdmin) {
        return (
            <PageWrapper>
                <Menu />
                <Cabecalho />
                <MainContent>
                    <Container>
                        <Titulo>Acesso Negado</Titulo>
                        <p>Apenas administradores podem acessar Comunicações Especiais.</p>
                    </Container>
                </MainContent>
            </PageWrapper>
        );
    }

    return (
        <PageWrapper>
            <Menu />
            <Cabecalho />
            <MainContent>
                <Container>
                    <Titulo>Comunicações Especiais</Titulo>
                    <p style={{ color: '#666', marginBottom: '16px' }}>
                        Automação de designações pendentes e pop-ups dinâmicos para os publicadores.
                    </p>

                    {erro && <ErrorMessage>{erro}</ErrorMessage>}

                    {/* ============== AUTOMACAO ============== */}
                    <SectionTitle>⚙️ Automação de Designações Pendentes</SectionTitle>
                    <AutomacaoBox>
                        {autoLoading ? (
                            <Loading>Carregando configuração...</Loading>
                        ) : (
                            <>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                    <span style={{ fontWeight: 600, color: '#333' }}>Disparo automático diário</span>
                                    <StatusPill $ativo={!!autoConfig?.ativo}>
                                        {autoConfig?.ativo ? '● Ativado' : '○ Desativado'}
                                    </StatusPill>
                                </div>

                                <ToggleRow style={{ marginTop: 12 }}>
                                    <BtnAtivar
                                        type="button"
                                        $ativo={!!autoConfig?.ativo}
                                        disabled={autoSalvando || !!autoConfig?.ativo}
                                        onClick={() => salvarConfigAutomacao({ ativo: true })}
                                    >
                                        Ativar
                                    </BtnAtivar>
                                    <BtnDesativar
                                        type="button"
                                        $ativo={!!autoConfig?.ativo}
                                        disabled={autoSalvando || !autoConfig?.ativo}
                                        onClick={() => salvarConfigAutomacao({ ativo: false })}
                                    >
                                        Desativar
                                    </BtnDesativar>
                                    {autoSalvando && <span style={{ fontSize: 12, color: '#008080' }}>salvando…</span>}
                                </ToggleRow>

                                <AutomacaoDescricao>
                                    Quando ativo, o sistema verifica todos os dias no horário escolhido as
                                    designações <strong>Pendentes</strong> cuja data está a até{' '}
                                    <strong>{autoConfig?.diasAntecedencia ?? 8} dias</strong> de hoje e envia ao
                                    publicador um push com <strong>Aceitar / Recusar</strong> na própria notificação.
                                    Se ainda estiver pendente a <strong>{autoConfig?.diasReforco ?? 2} dias</strong>,
                                    manda mais um aviso. Cada aviso é enviado no máximo uma vez.
                                </AutomacaoDescricao>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 12, flexWrap: 'wrap' }}>
                                    <span style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>Horário do disparo:</span>
                                    <Select
                                        value={autoConfig?.horaDisparo ?? 8}
                                        disabled={autoSalvando}
                                        onChange={(e) => salvarConfigAutomacao({ horaDisparo: Number(e.target.value) })}
                                        style={{ minWidth: 90 }}
                                    >
                                        {Array.from({ length: 24 }, (_, h) => (
                                            <option key={h} value={h}>{String(h).padStart(2, '0')}:00</option>
                                        ))}
                                    </Select>
                                    <span style={{ fontSize: 12, color: '#777' }}>(horário de Brasília)</span>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 12, flexWrap: 'wrap' }}>
                                    <span style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>Antecedência (dias):</span>
                                    <InputText
                                        type="number"
                                        min={1}
                                        max={60}
                                        value={autoConfig?.diasAntecedencia ?? 8}
                                        disabled={autoSalvando}
                                        onChange={(e) => salvarConfigAutomacao({ diasAntecedencia: Number(e.target.value) })}
                                        style={{ width: 80 }}
                                    />
                                    <span style={{ fontSize: 13, fontWeight: 600, color: '#333', marginLeft: 8 }}>Reforço (dias):</span>
                                    <InputText
                                        type="number"
                                        min={1}
                                        max={30}
                                        value={autoConfig?.diasReforco ?? 2}
                                        disabled={autoSalvando}
                                        onChange={(e) => salvarConfigAutomacao({ diasReforco: Number(e.target.value) })}
                                        style={{ width: 80 }}
                                    />
                                    {autoSalvando && <span style={{ fontSize: 12, color: '#008080' }}>salvando…</span>}
                                </div>

                                {autoConfig?.ultimoDisparo && (
                                    <div style={{ marginTop: 10, fontSize: 12, color: '#666' }}>
                                        Último disparo: {formatarData(autoConfig.ultimoDisparo)}
                                        {autoConfig.ultimoDisparoOrigem ? ` (${autoConfig.ultimoDisparoOrigem})` : ''}
                                        {autoConfig.ultimoResultado
                                            ? ` — ${(autoConfig.ultimoResultado.notificacoesInicial ?? 0) + (autoConfig.ultimoResultado.notificacoesReforco ?? 0)} aviso(s), ${autoConfig.ultimoResultado.enviosComSucesso ?? 0} push(es)`
                                            : ''}
                                    </div>
                                )}

                                {/* ---- Teste do disparo para um publicador ---- */}
                                <TesteWrap>
                                    <span style={{ fontSize: 13, fontWeight: 700, color: '#333' }}>
                                        🧪 Testar disparo para um publicador
                                    </span>
                                    <p style={{ fontSize: 12, color: '#666', margin: '6px 0 10px' }}>
                                        Envia agora, para o publicador escolhido, o push de <strong>Aceita / Recusa</strong> das
                                        designações <strong>Pendentes</strong> dele que caem na janela de antecedência
                                        ({autoConfig?.diasAntecedencia ?? 8} dias). Ignora o controle de repetição, então pode
                                        ser rodado várias vezes. Não altera o disparo automático.
                                    </p>

                                    {!testeSelecionado ? (
                                        <BuscaWrap>
                                            <InputText
                                                type="text"
                                                placeholder="🔍 Buscar publicador por nome..."
                                                value={testeBusca}
                                                onChange={(e) => { setTesteBusca(e.target.value); setTesteDropAberto(true); }}
                                                onFocus={() => setTesteDropAberto(true)}
                                                onBlur={() => setTimeout(() => setTesteDropAberto(false), 150)}
                                                style={{ width: '100%' }}
                                            />
                                            {testeDropAberto && (testeBuscando || testeResultados.length > 0 || testeBusca.trim().length >= 2) && (
                                                <BuscaDrop>
                                                    {testeBuscando && (
                                                        <div style={{ padding: '9px 12px', fontSize: 13, color: '#777' }}>Buscando…</div>
                                                    )}
                                                    {!testeBuscando && testeResultados.length === 0 && (
                                                        <div style={{ padding: '9px 12px', fontSize: 13, color: '#777' }}>Nenhum publicador encontrado.</div>
                                                    )}
                                                    {!testeBuscando && testeResultados.map((u) => (
                                                        <BuscaItem
                                                            key={u._id}
                                                            type="button"
                                                            onMouseDown={(e) => { e.preventDefault(); escolherUsuarioTeste(u); }}
                                                        >
                                                            <strong>{u.nome}</strong>
                                                            {u.email ? <span style={{ color: '#777' }}> · {u.email}</span> : null}
                                                            {u.temFcmToken === false ? <span style={{ color: '#c62828' }}> · sem token FCM</span> : null}
                                                        </BuscaItem>
                                                    ))}
                                                </BuscaDrop>
                                            )}
                                        </BuscaWrap>
                                    ) : (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                            <ChipUsuario>
                                                {testeSelecionado.nome}
                                                <ChipX type="button" title="Trocar" onClick={limparUsuarioTeste}>×</ChipX>
                                            </ChipUsuario>
                                            {testeSelecionado.temFcmToken === false && (
                                                <span style={{ fontSize: 12, color: '#c62828' }}>
                                                    (sem token FCM — só grava histórico, não entrega push)
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div style={{ marginTop: 12 }}>
                                        <PrimaryButton
                                            type="button"
                                            disabled={!testeSelecionado || testeDisparando}
                                            onClick={handleDispararTeste}
                                        >
                                            {testeDisparando ? 'Disparando…' : 'Disparar teste agora'}
                                        </PrimaryButton>
                                    </div>

                                    {testeMsg && (
                                        <div style={{
                                            marginTop: 10,
                                            fontSize: 13,
                                            fontWeight: 600,
                                            color: testeMsg.tipo === 'ok' ? '#1b5e20' : '#c62828',
                                        }}>
                                            {testeMsg.texto}
                                        </div>
                                    )}
                                </TesteWrap>

                            </>
                        )}
                    </AutomacaoBox>

                    {/* ============== COMUNICADOS ============== */}
                    <SectionTitle>📢 Comunicados (Pop-ups Dinâmicos)</SectionTitle>
                    <p style={{ color: '#666', fontSize: 13, marginBottom: 12 }}>
                        Monte pop-ups customizados (informativo, sim/não, enquete ou texto livre).
                        Os publicadores recebem no celular com o layout que você definir aqui.
                    </p>

                    <ToolbarCom>
                        <FiltrosContainer style={{ marginBottom: 0, flex: 1 }}>
                            <InputText
                                type="text"
                                placeholder="🔍 Buscar..."
                                value={buscaCom}
                                onChange={(e) => setBuscaCom(e.target.value)}
                                style={{ minWidth: 180 }}
                            />
                            <Select value={filtroTipoCom} onChange={(e) => setFiltroTipoCom(e.target.value)}>
                                <option value="todos">Todos os tipos</option>
                                <option value="informativo">Informativo</option>
                                <option value="sim_nao">Sim/Não</option>
                                <option value="multipla_escolha">Enquete</option>
                                <option value="texto_livre">Texto livre</option>
                            </Select>
                            <Select value={filtroStatusCom} onChange={(e) => setFiltroStatusCom(e.target.value)}>
                                <option value="ativos">Ativos</option>
                                <option value="inativos">Inativos</option>
                                <option value="todos">Todos status</option>
                            </Select>
                        </FiltrosContainer>
                        <PrimaryButton onClick={() => navigate('/comunicados/criar')}>
                            ➕ Criar Comunicado
                        </PrimaryButton>
                    </ToolbarCom>

                    {loadingCom ? (
                        <Loading>Carregando comunicados...</Loading>
                    ) : comunicadosFiltrados.length === 0 ? (
                        <EmptyState>
                            Nenhum comunicado encontrado. <a href="/comunicados/criar" style={{ color: '#008080' }}>Criar o primeiro</a>
                        </EmptyState>
                    ) : (
                        <Grid>
                            {comunicadosFiltrados.map((c) => (
                                <Card key={c._id}>
                                    <div>
                                        <Badge $tipo={c.tipoPopup}>{labelTipoPopup(c.tipoPopup)}</Badge>
                                        {c.obrigatorio && (
                                            <Badge $tipo="informativo" style={{ background: '#d32f2f' }}>
                                                OBRIGATORIO
                                            </Badge>
                                        )}
                                        {!c.ativo && (
                                            <Badge $tipo="texto_livre" style={{ background: '#999' }}>
                                                DESATIVADO
                                            </Badge>
                                        )}
                                    </div>
                                    <CardTitulo>{c.titulo}</CardTitulo>
                                    <CardMensagem>{c.mensagem}</CardMensagem>
                                    <CardInfo>
                                        <span>📅 {formatarData(c.createdAt)}</span>
                                        <span>👥 {c.totalEnvios || 0} envios</span>
                                        <span>💬 {c.totalRespostas || 0} respostas</span>
                                    </CardInfo>
                                    <CardAcoes>
                                        <SecondaryButton onClick={() => navigate(`/comunicados/${c._id}/resultados`)}>
                                            📊 Resultados
                                        </SecondaryButton>
                                        {c.ativo && (
                                            <SecondaryButton onClick={() => handleDispararCom(c._id)}>
                                                📤 Disparar
                                            </SecondaryButton>
                                        )}
                                        {c.ativo && (
                                            <DangerButton
                                                onClick={() => handleApagarCom(c)}
                                                disabled={desativandoId === c._id}
                                                title={c.totalEnvios > 0 ? 'Comunicado já foi disparado - não pode ser apagado (preserva resultados)' : 'Apagar comunicado'}
                                            >
                                                {c.totalEnvios > 0 ? '🔒 Apagado' : (desativandoId === c._id ? '...' : '🗑️ Apagar')}
                                            </DangerButton>
                                        )}
                                    </CardAcoes>
                                </Card>
                            ))}
                        </Grid>
                    )}

                    {/* ============== HISTORICO DAS POP-UPS ============== */}
                    <SectionTitle>📋 Histórico de Pop-ups Dinâmicos</SectionTitle>
                    <HistoricoBox>
                        {historicoPopups.length === 0 ? (
                            <EmptyState>Sem pop-ups no historico ainda.</EmptyState>
                        ) : (
                            historicoPopups.map((h) => (
                                <HistoricoItem key={h._id}>
                                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                                        <HistoricoBadge>{h.tipo?.toUpperCase()}</HistoricoBadge>
                                        <strong style={{ fontSize: 14 }}>{h.titulo}</strong>
                                    </div>
                                    <div style={{ fontSize: 13, color: '#555', marginTop: 4 }}>{h.mensagem}</div>
                                    <HistoricoInfo>
                                        📅 {formatarData(h.createdAt)} · de {h.enviadoPor?.nome || 'Sistema'}
                                    </HistoricoInfo>
                                </HistoricoItem>
                            ))
                        )}
                    </HistoricoBox>
                </Container>
            </MainContent>
            <Rodape />
        </PageWrapper>
    );
};

export default ComunicacoesEspeciais;
